export default __webpack_public_path__ + "static/7c2ff057824c76741aef116a52a42bfd.jpg";